import RejectTermsOrConsentDialog from ".";

export default function RejectTermsOrConsentDialogExamples() {
  const onClose = () => {
    console.log("closed");
  };

  return <RejectTermsOrConsentDialog isOpen={true} onClose={onClose} />;
}
